import styled from '@emotion/styled';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import backgroundImage from '../../assets/images/felder_schladen.jpeg';
import { customPalette } from '../../styles/theme';

export const LoggedOutContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: center;
  z-index: 1000;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px;
  background-color: ${customPalette.accent.main};
  border-radius: 18px;
  text-align: center;
  box-shadow:
    0 24px 32px 0 rgba(0, 0, 0, 0.04),
    0 16px 24px 0 rgba(0, 0, 0, 0.04),
    0 4px 8px 0 rgba(0, 0, 0, 0.04),
    0 0 1px 0 rgba(0, 0, 0, 0.04);
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  svg {
    max-width: 80px;
    margin-right: 12px;
  }
`;

export const LogoTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const LogoTitleBold = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: 0.15px;
  color: ${customPalette.accent.white};
`;

export const LogoSubtitle = styled.div`
  font-size: 14px;
  font-weight: normal;
  line-height: 120%;
  color: ${customPalette.accent.white};
`;

export const Title = styled.h1`
  color: ${customPalette.accent.white};
  text-align: center;
  margin-top: 48px;
  margin-bottom: 48px;
  font-size: 22px;
  font-weight: 700;
  line-height: 100%;
`;

export const FooterLinks = styled.div`
  color: ${customPalette.accent.white};
  font-size: 12px;
  font-weight: 400;
  line-height: 100%;
  letter-spacing: 0.2px;
  text-align: center;
  margin-bottom: 24px;
  margin-top: 24px;

  a {
    color: ${customPalette.accent.white};
    text-decoration: none;
    margin: 0 8px;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const FooterText = styled.div`
  color: ${customPalette.accent.white};
  font-size: 12px;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  text-align: center;
`;
